export default function formatDate(dateString) {
    const formattedDate = new Date(dateString.replace(/Z$/, '')).toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
    return formattedDate;
}